import React, { createContext, useContext } from "react";

export enum Partner {
    NONE = "NONE",
    U_SWITCH = "uSwitch",
    EMMA = "emma",
    FORBES = "forbes",
    BRITISH_HOME_SELLERS = "british-home-sellers"
}

const PartnerContext = createContext<Partner>(Partner.NONE);
export const usePartnerContext = () => useContext(PartnerContext);

interface IProps {
  children: React.ReactNode;
  partnerStr?: string;
}

const PARTNER_MAPPER: { [key: string]: Partner } = {
  uSwitch: Partner.U_SWITCH,
  emma: Partner.EMMA,
  forbes: Partner.FORBES,
  "british-home-sellers": Partner.BRITISH_HOME_SELLERS,
};

const getPartner = (partnerStr?: string) : Partner => (partnerStr ? PARTNER_MAPPER[partnerStr] : Partner.NONE);

export const PartnerProvider = ({ partnerStr, children }: IProps) => (
  <PartnerContext.Provider value={getPartner(partnerStr)}>
    {children}
  </PartnerContext.Provider>
);
